<template>
<div class="main">
    <topBar />
    <div class="wrap">
        <router-view />
    </div>
    <footerBar />
</div>
</template>

<script>
import topBar from '@/components/common/topbar.vue';
import footerBar from '@/components/common/footer-bar.vue';
export default {
    inject: ['reload'],
    components:{topBar,footerBar},
    data () {
        return {}
    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
.main{
    min-width: 1340px;
}
.wrap{
    min-height: calc(100vh - 128px);
    box-sizing: border-box;
    background: #3A3835;
    @media (max-width: 1500px){
        // padding: 0 3.3% 50px 3.3%;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue